export const ADD_DATA_SOURCE_PANEL_CLASS_NAME = 'add-data-source-panel';
export const DATA_PANEL_CLASS_NAME = 'data-panel-container';
export const DATA_TOKEN_POPOVER_DATA_ATTR = 'data-token-popover';
const isClickEventFromDOM = ({
  eventTarget,
  elementDomToEval
}) => {
  if (!eventTarget || !elementDomToEval) {
    return false;
  }
  if (eventTarget === elementDomToEval) {
    return true;
  }
  if (elementDomToEval.contains(eventTarget)) {
    return true;
  }
  return false;
};
export const isClickEventFromAddDataSourcePanel = ({
  target
}) => {
  const elementDomToEval = document.getElementsByClassName(ADD_DATA_SOURCE_PANEL_CLASS_NAME)[0];
  return isClickEventFromDOM({
    eventTarget: target,
    elementDomToEval
  });
};
export const isClickEventFromDataPanel = ({
  target
}) => {
  const elementDomToEval = document.getElementsByClassName(DATA_PANEL_CLASS_NAME)[0];
  return isClickEventFromDOM({
    eventTarget: target,
    elementDomToEval
  });
};
export const isClickEventFromDataTokenPopover = ({
  target
}) => {
  const elementDomToEval = document.querySelector(`[${DATA_TOKEN_POPOVER_DATA_ATTR}]`);
  return isClickEventFromDOM({
    eventTarget: target,
    elementDomToEval
  });
};